import { useCallback } from 'react'
import {
  ICreateInboundFileRouterConfigInput,
  IUpdateInboundFileRouterConfigInput,
} from 'types/graphqlTypes'
import { useGlobalToast } from 'transfix-ui'
import { useCreateEdiInboundFileRouterConfigMutation } from '../graphql/CreateEdiInboundFileRouterConfig'
import { useUpdateEdiInboundFileRouterConfigMutation } from '../graphql/UpdateEdiInboundFileRouterConfig'

export const useInboundFileRouterConfig = () => {
  const [createEdiInboundFileRouterConfigMutation] = useCreateEdiInboundFileRouterConfigMutation()
  const [updateEdiInboundFileRouterConfigMutation] = useUpdateEdiInboundFileRouterConfigMutation()

  const { openToast } = useGlobalToast()

  const createInboundFileRouterConfig = useCallback(
    async (input: ICreateInboundFileRouterConfigInput) => {
      try {
        const response = await createEdiInboundFileRouterConfigMutation({
          variables: {
            input,
          },
          refetchQueries: ['EdiInboundFileRouterConfigs'],
        })

        const { data } = response || {}
        const { createInboundFileRouterConfig } = data || {}
        const { errors = [] } = createInboundFileRouterConfig || {}

        const filteredErrors = errors.filter(item => !!item.message).map(i => i.message)

        if (filteredErrors.length > 0) {
          openToast({
            toastMessage: filteredErrors.join(', '),
            toastType: 'alert',
            toastDuration: null,
          })
          return
        }

        openToast({
          toastMessage: 'Inbound File Router Config created successfully.',
          toastType: 'default',
        })
      } catch (e) {
        openToast({ toastMessage: e.message, toastType: 'alert' })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [createEdiInboundFileRouterConfigMutation]
  )

  const updateInboundFileRouterConfig = useCallback(
    async (input: IUpdateInboundFileRouterConfigInput) => {
      try {
        const response = await updateEdiInboundFileRouterConfigMutation({
          variables: {
            input,
          },
          refetchQueries: ['EdiInboundFileRouterConfigs'],
        })
        const { data } = response || {}
        const { updateInboundFileRouterConfig } = data || {}
        const { errors = [] } = updateInboundFileRouterConfig || {}

        const filteredErrors = errors.filter(item => !!item.message).map(i => i.message)

        if (filteredErrors.length > 0) {
          openToast({
            toastMessage: filteredErrors.join(', '),
            toastType: 'alert',
            toastDuration: null,
          })
          return
        }

        openToast({
          toastMessage: 'Inbound File Router Config updated successfully.',
          toastType: 'default',
        })
      } catch (e) {
        openToast({ toastMessage: e.message, toastType: 'alert' })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateEdiInboundFileRouterConfigMutation]
  )

  return {
    createInboundFileRouterConfig,
    updateInboundFileRouterConfig,
  }
}
